import React from 'react';

import { Modal } from '@companycam/slab-web';
import PromoModalVideoPlayer from 'components/shared/PromoModalVideoPlayer';

export type WatchDemoModalProps = {
  onRequestClose: () => void;
};

const youtubeSrc =
  'https://www.youtube.com/watch?v=6Dongj2SMic&list=PLofZHnNDVSI2zCD_RwDip1_79dLmrz7VG&index=6';

const WatchDemoModal = ({ onRequestClose }: WatchDemoModalProps) => {
  return (
    <Modal
      isOpen
      title=""
      onClose={onRequestClose}
      headerComponent={null}
      footerComponent={null}
    >
      <PromoModalVideoPlayer youtubeSrc={youtubeSrc} />
    </Modal>
  );
};

export default WatchDemoModal;
